export default "__VITE_ASSET__e9e4b2af__"